import { render, staticRenderFns } from "./RegexSelector.vue?vue&type=template&id=2da97627&scoped=true&"
import script from "./RegexSelector.vue?vue&type=script&lang=js&"
export * from "./RegexSelector.vue?vue&type=script&lang=js&"
import style0 from "./RegexSelector.vue?vue&type=style&index=0&id=2da97627&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da97627",
  null
  
)

export default component.exports